import { render, staticRenderFns } from "./tool-edit-info-favorite.vue?vue&type=template&id=a7e050fa&scoped=true&"
import script from "./tool-edit-info-favorite.vue?vue&type=script&lang=js&"
export * from "./tool-edit-info-favorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e050fa",
  null
  
)

export default component.exports